import { setup } from 'xstate';

export type RequestOverrideEvent =
  | { type: 'OPEN' }
  | { type: 'CLOSE' }
  | { type: 'CONFIRM' };

export const requestOverrideMachine = setup({
  types: {
    events: {} as RequestOverrideEvent,
  },
}).createMachine({
  id: 'requestOverride',
  initial: 'closed',
  states: {
    closed: {
      on: {
        OPEN: 'open',
      },
    },
    open: {
      on: {
        CLOSE: 'closed',
        CONFIRM: 'closed',
      },
    },
  },
});
